import React, {useState} from "react"
import OtherServiceSelector from "./OtherServiceSelector";
import SpecialInspection from "./SpecialInspection";
import RegistrationService from "./RegistrationService";

const OtherServices = () => {
    const [selectedAction, setSelectedAction] = useState(null);

    return (<>
        {selectedAction === null &&
            <OtherServiceSelector onSelect={setSelectedAction}/>
        }
        {selectedAction === "registrationService" &&
            <RegistrationService onBack={() => setSelectedAction(null)}/>
        }
        {selectedAction === "specialInspection" &&
            <SpecialInspection onBack={() => setSelectedAction(null)} queueType="specialInspection"/>
        }
        {selectedAction === "changeInspection" &&
            <SpecialInspection onBack={() => setSelectedAction(null)} queueType="changeInspection"/>
        }
        {selectedAction === "registrationInspection" &&
            <SpecialInspection onBack={() => setSelectedAction(null)} queueType="registrationInspection"/>
        }
    </>)
}

export default OtherServices
